import Cookies from 'js-cookie';

var TokenDomain = /* @__PURE__ */ ((TokenDomain2) => {
  TokenDomain2["Forms"] = "forms";
  TokenDomain2["DigiSign"] = "digisign";
  TokenDomain2["Prime"] = "prime";
  TokenDomain2["Portal"] = "portal";
  TokenDomain2["Accounts"] = "accounts";
  TokenDomain2["Sklosures"] = "sklosures";
  TokenDomain2["Marketplace"] = "marketplace";
  TokenDomain2["Events"] = "events";
  TokenDomain2["Global"] = "global";
  TokenDomain2["External"] = "external";
  return TokenDomain2;
})(TokenDomain || {});
var TokenType = /* @__PURE__ */ ((TokenType2) => {
  TokenType2["Access"] = "accessToken";
  TokenType2["Id"] = "idToken";
  TokenType2["Refresh"] = "refreshToken";
  return TokenType2;
})(TokenType || {});

var StorageKey = /* @__PURE__ */ ((StorageKey2) => {
  StorageKey2["Logout"] = "com.skyslope.logout";
  StorageKey2["Token"] = "com.skyslope.id.tokens";
  StorageKey2["LastIdentityProvider"] = "com.skyslope.id.idp";
  StorageKey2["Session"] = "com.skyslope.id.session";
  StorageKey2["ImpersonatedUser"] = "com.skyslope.id.impersonation";
  return StorageKey2;
})(StorageKey || {});
var TokenStorageKey = /* @__PURE__ */ ((TokenStorageKey2) => {
  TokenStorageKey2["Forms"] = "forms";
  TokenStorageKey2["DigiSign"] = "ds";
  TokenStorageKey2["Prime"] = "dtm";
  TokenStorageKey2["Portal"] = "cp";
  TokenStorageKey2["Accounts"] = "acc";
  TokenStorageKey2["Sklosures"] = "skl";
  TokenStorageKey2["Marketplace"] = "mrkp";
  TokenStorageKey2["Events"] = "events";
  TokenStorageKey2["Global"] = "global";
  TokenStorageKey2["External"] = "external";
  return TokenStorageKey2;
})(TokenStorageKey || {});
const validateIdp = (idp) => {
  const regex = /^0oa(\w){15,25}$/i;
  const matches = regex.exec(idp);
  return !!matches;
};
const getLastIdp = () => {
  var _a;
  const lastIdp = (_a = localStorage.getItem("com.skyslope.id.idp" /* LastIdentityProvider */)) != null ? _a : "";
  return validateIdp(lastIdp) ? lastIdp : null;
};
const setLastIdp = (idp) => {
  if (validateIdp(idp)) {
    localStorage.setItem("com.skyslope.id.idp" /* LastIdentityProvider */, idp);
  } else {
    localStorage.removeItem("com.skyslope.id.idp" /* LastIdentityProvider */);
  }
};
const isLoggingOut = () => {
  const val = localStorage.getItem("com.skyslope.logout" /* Logout */);
  if (val) {
    const expirationTime = JSON.parse(val);
    const now = new Date();
    if (now.getTime() < expirationTime) {
      return true;
    }
    localStorage.removeItem("com.skyslope.logout" /* Logout */);
  }
  return false;
};
const clearLoggingOut = () => {
  localStorage.removeItem("com.skyslope.logout" /* Logout */);
};
const setLoggingOut = () => {
  const now = new Date();
  const ttl = 10 * 1e3;
  localStorage.setItem("com.skyslope.logout" /* Logout */, JSON.stringify(now.getTime() + ttl));
};
const setSessionless = () => {
  sessionStorage.setItem("com.skyslope.id.session" /* Session */, `${false}`);
};
const isSessionless = () => {
  const val = sessionStorage.getItem("com.skyslope.id.session" /* Session */);
  return !!val && val === `${false}`;
};
const clearSessionless = () => {
  sessionStorage.removeItem("com.skyslope.id.session" /* Session */);
};
const storeImpersonatedUser = (user) => {
  if (user) {
    sessionStorage.setItem("com.skyslope.id.impersonation" /* ImpersonatedUser */, JSON.stringify(user));
  } else {
    sessionStorage.removeItem("com.skyslope.id.impersonation" /* ImpersonatedUser */);
  }
};
const getImpersonatedUser = () => {
  const val = sessionStorage.getItem("com.skyslope.id.impersonation" /* ImpersonatedUser */);
  return val ? JSON.parse(val) : null;
};
const tokenStorage = {
  [TokenDomain.Forms]: "forms" /* Forms */,
  [TokenDomain.DigiSign]: "ds" /* DigiSign */,
  [TokenDomain.Prime]: "dtm" /* Prime */,
  [TokenDomain.Portal]: "cp" /* Portal */,
  [TokenDomain.Accounts]: "acc" /* Accounts */,
  [TokenDomain.Sklosures]: "skl" /* Sklosures */,
  [TokenDomain.Marketplace]: "mrkp" /* Marketplace */,
  [TokenDomain.Events]: "events" /* Events */,
  [TokenDomain.Global]: "global" /* Global */,
  [TokenDomain.External]: "external" /* External */
};
const getTokenStorage = (domain, type) => `${tokenStorage[domain]}${type === TokenType.Id ? "IdToken" : "AccessToken"}`;

const CookieDomain = ".skyslope.com";
var Cookie = /* @__PURE__ */ ((Cookie2) => {
  Cookie2["ImpersonationUserId"] = "impersonation_user_id";
  return Cookie2;
})(Cookie || {});
const observeImpersonationChanges = (env, callback, interval = 1e3) => {
  const cookieName = env.cookies.impersonationUserId;
  let lastValue = Cookies.get(cookieName);
  setInterval(() => {
    const value = Cookies.get(cookieName);
    if (value !== lastValue) {
      try {
        callback(value);
      } finally {
        lastValue = value;
      }
    }
  }, interval);
};
const getImpersonatedId = (env) => {
  var _a;
  return (_a = Cookies.get(env.cookies.impersonationUserId)) != null ? _a : null;
};
const impersonateUser = (env, id) => {
  const cookieName = env.cookies.impersonationUserId;
  const isSSR = typeof window === "undefined";
  const isLocal = isSSR ? false : window.location.host.includes("localhost");
  const cookieOpts = {
    domain: !isLocal ? CookieDomain : void 0,
    sameSite: !isLocal ? "None" : void 0,
    secure: !isLocal
  };
  if (id !== null) {
    Cookies.set(cookieName, id, cookieOpts);
  } else {
    Cookies.remove(cookieName, cookieOpts);
    storeImpersonatedUser(null);
  }
};

class IdentityProvidersImpl {
  constructor(providers) {
    Object.assign(this, providers);
  }
  get last() {
    return getLastIdp();
  }
}

var Environment = /* @__PURE__ */ ((Environment2) => {
  Environment2["Integ"] = "integ";
  Environment2["Staging"] = "staging";
  Environment2["Prod"] = "prod";
  return Environment2;
})(Environment || {});
const environmentSettings = {
  integ: {
    accountsApi: {
      baseUrl: "https://accounts-integ.skyslope.com/api"
    },
    cookies: {
      impersonationUserId: `${Cookie.ImpersonationUserId}_integ`
    },
    okta: {
      baseUrl: "https://id-integ.skyslope.com",
      idps: new IdentityProvidersImpl({
        jumpcloud: "0oarsi7g6qx3bntdx357",
        primeAuth: "0oa154s1ybu3Lbyo6357",
        social: {
          google: "0oa6fqervuELjZKeR357",
          facebook: "",
          linkedin: ""
        },
        associations: {
          realmls: "0oaqifc7xty9Yjy08357",
          gaar: "0oatrlvjlrianxfdG357",
          glar: "0oalnsuknzzYmxjt2357",
          nmmls: "0oaskiydb6nKt2354357",
          paragon: "0oau3gerbumcJc2vS357",
          recolorado: "0oatl4kxw6sbYOwzG357",
          sfaor: "0oarpp9g2i8fsTua8357",
          stellar: "0oa1g7ylyk7byIJ4f358",
          trreb: "0oanzsqlklkcLduFU357",
          ure: "0oaf2eiyp0ktG9KZd357",
          weichert: "0oasq2cdryk8Z0kZL357",
          trreb_amp: "0oaymys5ltETVoLMr357",
          bright: "0oa10wo5z1jShuf8o358",
          silvercity: "0oa167t5zufpYQ1M2358",
          alamogordo: "0oa16937brvGILa5r358",
          newmexico: "0oa1693aykcmpCnUN358",
          taosmls: "0oa16l1adynKiUmZj358",
          realcomp: "0oa1jd3pk4c9qXFIp358"
        },
        platforms: {
          flex_mls: "0oaqifc7xty9Yjy08357"
        },
        brokers: {
          nexthome: "0oa1aulwowv4KtffG358",
          nexthome_test: "0oa1aut5uxdpbLaHs358",
          douglasselliman: "0oa1k1yip3cKE4vPf358"
        }
      }),
      idpDiscovery: {
        requestContext: "aln177a159h7Zf52X0g8"
      },
      audiences: {
        [TokenDomain.Forms]: "integ-forms.skyslope.com",
        [TokenDomain.DigiSign]: "integ-send.skyslope.com",
        [TokenDomain.Prime]: "integ.skyslope.com",
        [TokenDomain.Portal]: "integ-marketplace.skyslope.com",
        [TokenDomain.Accounts]: "accounts-integ.skyslope.com",
        [TokenDomain.Sklosures]: "integ-sklosures.skyslope.com",
        [TokenDomain.Marketplace]: "integ-marketplace.skyslope.com",
        [TokenDomain.Events]: "integ-events.skyslope.com",
        [TokenDomain.Global]: "integ.skyslope.com",
        [TokenDomain.External]: "api-integ.skyslope.com"
      },
      servers: {
        [TokenDomain.Forms]: "aus1589ztbT5gAqTt357",
        [TokenDomain.DigiSign]: "aus15nfoj3xGfAiHp357",
        [TokenDomain.Prime]: "aus1cq5dlw6SxDCNk357",
        [TokenDomain.Portal]: "aus1cq5vc59HGEwir357",
        [TokenDomain.Accounts]: "aus6yz9ifmOXfZZ7F357",
        [TokenDomain.Sklosures]: "aus84ddsudukvdm93357",
        [TokenDomain.Marketplace]: "ausectp14jxa3jF4U357",
        [TokenDomain.Events]: "aus9xlydn99lJqudF357",
        [TokenDomain.Global]: "ausku1rdgaFoooRXy357",
        [TokenDomain.External]: "ausyjjs5cghtKAr6C357"
      }
    },
    primeAuth: {
      baseUrl: "https://integ-auth.skyslope.com"
    },
    tokenExchange: {
      baseUrl: "https://integ-token-exchange.skyslope.com"
    }
  },
  staging: {
    accountsApi: {
      baseUrl: "https://accounts-staging.skyslope.com/api"
    },
    cookies: {
      impersonationUserId: `${Cookie.ImpersonationUserId}_staging`
    },
    okta: {
      baseUrl: "https://id-staging.skyslope.com",
      idps: new IdentityProvidersImpl({
        jumpcloud: "0oa1mzi13e6aOEMnm0h8",
        primeAuth: "0oapx40qvxeQeNory0h7",
        social: {
          google: "0oavxfqs852euKAPJ0h7",
          facebook: "",
          linkedin: ""
        },
        associations: {
          realmls: "0oa1l57z19jmEu4CY0h8",
          gaar: "0oa1qlob3adoA4ByW0h8",
          glar: "0oa1cpgaa4bTkehmt0h8",
          nmmls: "0oa1oahp792BC1VaP0h8",
          paragon: "0oa1r97319iQXjr2X0h8",
          recolorado: "0oa1qa2fjlyGS3gLC0h8",
          sfaor: "0oa1mw6izpcsNj0Zr0h8",
          stellar: "0oa2bbew4s9RDmiNw0h8",
          trreb: "0oa1gqx8kqfGjudcL0h8",
          ure: "0oa14mkhfzq0zmL6O0h8",
          weichert: "0oa1opcaxlnMzImzg0h8",
          trreb_amp: "0oa1xiy3sq7WZVF100h8",
          bright: "0oa1zmsf0yx63TSW60h8",
          silvercity: "0oa245xhnsikVMAKM0h8",
          alamogordo: "0oa2470i5417Q1D8s0h8",
          newmexico: "0oa2470gibyYogeAF0h8",
          taosmls: "0oa24f98txzc6lBlL0h8",
          realcomp: "0oa2dorm46jScm0pa0h8"
        },
        platforms: {
          flex_mls: "0oa1l57z19jmEu4CY0h8"
        },
        brokers: {
          nexthome: "0oa27lkyydwnnIS9y0h8",
          nexthome_test: "0oa27lpp2ofa8RN1g0h8",
          douglasselliman: "0oa2e7anlmjfhn8ra0h8"
        }
      }),
      idpDiscovery: {
        requestContext: "aln5z7uhkbM6y7bMy0g7"
      },
      audiences: {
        [TokenDomain.Forms]: "staging-forms.skyslope.com",
        [TokenDomain.DigiSign]: "staging-send.skyslope.com",
        [TokenDomain.Prime]: "staging.skyslope.com",
        [TokenDomain.Portal]: "consumer-portal-staging.skyslope.com",
        [TokenDomain.Accounts]: "accounts-staging.skyslope.com",
        [TokenDomain.Sklosures]: "staging-sklosures.skyslope.com",
        [TokenDomain.Marketplace]: "staging-marketplace.skyslope.com",
        [TokenDomain.Events]: "staging-events.skyslope.com",
        [TokenDomain.Global]: "staging.skyslope.com",
        [TokenDomain.External]: "api-staging.skyslope.com"
      },
      servers: {
        [TokenDomain.Forms]: "auspx3z6bi3weJs200h7",
        [TokenDomain.DigiSign]: "ausq0hw1h65nne9mH0h7",
        [TokenDomain.Prime]: "ausquu70rwMQgJiiI0h7",
        [TokenDomain.Portal]: "ausqkbojps2ueDB0v0h7",
        [TokenDomain.Accounts]: "ausw3fzshkCAFIQyz0h7",
        [TokenDomain.Sklosures]: "ausy7c4535h3fjYn60h7",
        [TokenDomain.Marketplace]: "aus14iukmjwRFywvn0h8",
        [TokenDomain.Events]: "auszowob5oUTzf4DS0h7",
        [TokenDomain.Global]: "aus1bkfxhlqGHEN1W0h8",
        [TokenDomain.External]: "aus1z0e7pvirVphOC0h8"
      }
    },
    primeAuth: {
      baseUrl: "https://staging-auth.skyslope.com"
    },
    tokenExchange: {
      baseUrl: "https://staging-token-exchange.skyslope.com"
    }
  },
  prod: {
    accountsApi: {
      baseUrl: "https://accounts.skyslope.com/api"
    },
    cookies: {
      impersonationUserId: Cookie.ImpersonationUserId
    },
    okta: {
      baseUrl: "https://id.skyslope.com",
      idps: new IdentityProvidersImpl({
        jumpcloud: "0oachozqyfXzhZDO74x7",
        primeAuth: "0oa25qgk2HCoSakYh4x6",
        social: {
          google: "0oa1m2n285zqjK6TZ4x7",
          facebook: "",
          linkedin: ""
        },
        associations: {
          realmls: "0oabsb644woLs3wa84x7",
          gaar: "0oadinpz7aUmevH074x7",
          glar: "0oa95p71hbbd75z2d4x7",
          nmmls: "0oacx45di3r7pxfpM4x7",
          paragon: "0oadoceuwpD2aHMt64x7",
          recolorado: "0oadfgycdcBjksXeB4x7",
          sfaor: "0oachoxglqtJKI6sI4x7",
          stellar: "0oaplywdxdg658uhf4x7",
          trreb: "0oaaftsyy6URtUrmx4x7",
          ure: "0oa5u9ufcgFB9hWmi4x7",
          weichert: "0oacxxvm380uIAjlD4x7",
          trreb_amp: "0oag7by4xhNQHtdEC4x7",
          bright: "0oahgcex3i5Rg6qwg4x7",
          silvercity: "0oak7ci157W8rtkOe4x7",
          alamogordo: "0oak7y5vzeDtLMM1u4x7",
          newmexico: "0oak7y6zm3xG8wjXY4x7",
          taosmls: "0oakdtkf5mjzivcGd4x7",
          realcomp: "0oar3m9n09O0g1dJs4x7"
        },
        platforms: {
          flex_mls: "0oabsb644woLs3wa84x7"
        },
        brokers: {
          nexthome: "0oampiuhbxmNVCG5C4x7",
          nexthome_test: "0oampip523O5VrktP4x7",
          douglasselliman: "0oarf9dx78BY5eVEA4x7"
        }
      }),
      idpDiscovery: {
        requestContext: "aln177a159h7Zf52X0g8"
      },
      audiences: {
        [TokenDomain.Forms]: "forms.skyslope.com",
        [TokenDomain.DigiSign]: "send.skyslope.com",
        [TokenDomain.Prime]: "app.skyslope.com",
        [TokenDomain.Portal]: "consumer-portal.skyslope.com",
        [TokenDomain.Accounts]: "accounts.skyslope.com",
        [TokenDomain.Sklosures]: "sklosures.skyslope.com",
        [TokenDomain.Marketplace]: "marketplace.skyslope.com",
        [TokenDomain.Events]: "events.skyslope.com",
        [TokenDomain.Global]: "skyslope.com",
        [TokenDomain.External]: "api.skyslope.com"
      },
      servers: {
        [TokenDomain.Forms]: "aus25q3otn0cUfwED4x6",
        [TokenDomain.DigiSign]: "aus2ukovqrWcy6TUw4x6",
        [TokenDomain.Prime]: "aus911kfa5Gt6NlfI4x6",
        [TokenDomain.Portal]: "aus4yw7a5yvd4IL694x6",
        [TokenDomain.Accounts]: "aus1nlsmdkBSnrhoa4x7",
        [TokenDomain.Sklosures]: "aus2t5ddm2TjnKomG4x7",
        [TokenDomain.Marketplace]: "aus5qtq241p3s3sRh4x7",
        [TokenDomain.Events]: "aus3h5uq8dZGPz0Kj4x7",
        [TokenDomain.Global]: "aus8pzz1opXBU13vM4x7",
        [TokenDomain.External]: "aush1zfdxi1sIfBms4x7"
      }
    },
    primeAuth: {
      baseUrl: "https://auth.skyslope.com"
    },
    tokenExchange: {
      baseUrl: "https://token-exchange.skyslope.com"
    }
  }
};
const getEnvironmentSettings = (env) => environmentSettings[env];

var RecoveryFactor = /* @__PURE__ */ ((RecoveryFactor2) => {
  RecoveryFactor2["Email"] = "EMAIL";
  RecoveryFactor2["Sms"] = "SMS";
  RecoveryFactor2["Call"] = "CALL";
  return RecoveryFactor2;
})(RecoveryFactor || {});

var Params = /* @__PURE__ */ ((Params2) => {
  Params2["DelegatedUserId"] = "delegated_user_id";
  return Params2;
})(Params || {});
var Scope = /* @__PURE__ */ ((Scope2) => {
  Scope2["OpenId"] = "openid";
  Scope2["Email"] = "email";
  Scope2["Profile"] = "profile";
  Scope2["SkySlopeGroups"] = "com.skyslope.groups";
  Scope2["SkySlopeSupport"] = "com.skyslope.support";
  Scope2["PrimeSubscriber"] = "com.skyslope.prime.subscriber";
  Scope2["FormsApi"] = "com.skyslope.forms.api";
  Scope2["FormsAccountId"] = "com.skyslope.forms.accountid";
  Scope2["DigiSignUserId"] = "com.skyslope.digisign.userid";
  Scope2["Marketplace"] = "com.skyslope.marketplace.api";
  Scope2["DigiSignEventsSub"] = "com.skyslope.events.digisign.sub";
  Scope2["FormsEventsSub"] = "com.skyslope.events.forms.sub";
  Scope2["PrimeEventsSub"] = "com.skyslope.events.prime.sub";
  Scope2["EventHook"] = "com.skyslope.event.hook";
  return Scope2;
})(Scope || {});
var ResponseType = /* @__PURE__ */ ((ResponseType2) => {
  ResponseType2["Code"] = "code";
  ResponseType2["IdToken"] = "id_token";
  ResponseType2["Token"] = "token";
  ResponseType2["IdTokenToken"] = "id_token token";
  return ResponseType2;
})(ResponseType || {});

const parseTokenDomain = (url, servers) => {
  const regex = /.*\/oauth2\/(.*)\/v1\/authorize/i;
  const matches = regex.exec(url);
  if (!matches) {
    return null;
  }
  const authServerId = matches[1];
  const tokenDomain = Object.keys(servers).find(
    (key) => servers[key] === authServerId
  );
  return tokenDomain;
};
const parseBaseUrl = (url) => {
  for (const env in Environment) {
    const baseUrl = getEnvironmentSettings(
      Environment[env]
    ).okta.baseUrl;
    if (url.startsWith(baseUrl)) {
      return baseUrl;
    }
  }
  return null;
};
const validatePassword = (password, profile) => {
  const pass = password.toLowerCase();
  const first = profile.firstName.toLowerCase();
  const last = profile.lastName.toLowerCase();
  const passContainsName = pass.includes(first) || pass.includes(last);
  return passContainsName ? ["Your password cannot contain your name"] : [];
};

const getUserProfileFromClaims = (claims) => {
  var _a, _b, _c;
  const profile = {
    id: claims.sub,
    email: (_a = claims.email) != null ? _a : "",
    firstName: (_b = claims.first_name) != null ? _b : "",
    middleName: claims.middle_name,
    lastName: (_c = claims.last_name) != null ? _c : "",
    primaryPhone: claims.primary_phone,
    oktaGroups: claims.groups,
    nrdsId: claims.nrds_id,
    loginId: claims.login_id,
    delegatedUserId: claims.delegated_user_id
  };
  if (claims.prime_user_id || claims.subscriber_id || claims.prime_contact_id || claims.prime_contact_type) {
    profile.prime = {
      userId: claims.prime_user_id,
      subscriberId: claims.subscriber_id,
      contactId: claims.prime_contact_id,
      contactType: claims.prime_contact_type
    };
  }
  if (claims.digisign_user_id) {
    profile.digisign = {
      userId: claims.digisign_user_id
    };
  }
  return profile;
};

export { Cookie, CookieDomain, Environment, IdentityProvidersImpl, Params, RecoveryFactor, ResponseType, Scope, StorageKey, TokenDomain, TokenStorageKey, TokenType, clearLoggingOut, clearSessionless, getEnvironmentSettings, getImpersonatedId, getImpersonatedUser, getLastIdp, getTokenStorage, getUserProfileFromClaims, impersonateUser, isLoggingOut, isSessionless, observeImpersonationChanges, parseBaseUrl, parseTokenDomain, setLastIdp, setLoggingOut, setSessionless, storeImpersonatedUser, validateIdp, validatePassword };
